import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export interface Choice {
  date: string;
  time: string | null;
  options: core.IOptionOrder[];
  questions: {};
  confirmed: boolean;
}

interface State {
  selectedPackageId: number | null;
  size: number | null;
  choices: {
    [ticketTypeId: string]: Choice;
  };
}

const initialState: State = {
  selectedPackageId: null,
  size: null,
  choices: {},
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.PACKAGE_CLEAR: {
      return {
        ...initialState,
      };
    }
    case AppConstants.PACKAGE_SELECT_PACKAGE: {
      return {
        selectedPackageId: payload,
        size: null,
        choices: {},
      };
    }

    case AppConstants.PACKAGE_SELECT_SIZE: {
      return {
        ...state,
        size: payload,
        choices: {},
      };
    }

    case AppConstants.PACKAGE_SELECT_DATE: {
      const { ticketTypeId, date }: { ticketTypeId: number; date: string } = payload;
      return {
        ...state,
        choices: {
          ...state.choices,
          [`${ticketTypeId}`]: {
            date,
            time: null,
            options: [],
            questions: {},
            confirmed: false,
          },
        },
      };
    }

    case AppConstants.PACKAGE_SELECT_TIME: {
      const { ticketTypeId, time }: { ticketTypeId: number; time: string } = payload;
      const choice: Choice = state.choices[ticketTypeId];

      return {
        ...state,
        choices: {
          ...state.choices,
          [`${ticketTypeId}`]: {
            ...choice,
            time,
          },
        },
      };
    }

    case AppConstants.PACKAGE_SELECT_OPTIONS: {
      const { ticketTypeId, options }: { ticketTypeId: number; options: core.IOptionOrder[] } =
        payload;
      const choice: Choice = state.choices[ticketTypeId];

      return {
        ...state,
        choices: {
          ...state.choices,
          [`${ticketTypeId}`]: {
            ...choice,
            options: [...options],
          },
        },
      };
    }

    case AppConstants.PACKAGE_CONFIRM_CHOICES: {
      const { ticketTypeId }: { ticketTypeId: number } = payload;
      const choice: Choice = state.choices[ticketTypeId];

      return {
        ...state,
        choices: {
          ...state.choices,
          [`${ticketTypeId}`]: {
            ...choice,
            confirmed: true,
          },
        },
      };
    }

    case AppConstants.PACKAGE_EDIT_CHOICES: {
      const { ticketTypeId }: { ticketTypeId: number } = payload;
      const choice: Choice = state.choices[ticketTypeId];

      return {
        ...state,
        choices: {
          ...state.choices,
          [`${payload.ticketTypeId}`]: {
            ...choice,
            confirmed: false,
          },
        },
      };
    }

    default:
      return state;
  }
}
